<template>
  <div class="row mt-4 mb-2 inner-nav-buttons">
    <router-link
      :to="detailsRoute"
      class="col-20 col-sm-6 col-md-4"
    >
      {{ $t('view-UserProfile.button.nav.about') }}
    </router-link>
    <router-link
      :to="audienceRoute"
      class="col-20 mt-3 mt-sm-0 col-sm-6 col-md-4 offset-sm-1"
    >
      {{ $t('view-UserProfile.button.nav.audience') }}
    </router-link>
  </div>
</template>

<script>
import '../../../assets/scss/inner-nav-buttons.scss'

export default {
  props: {
    detailsRoute: {
      type: Object,
      default: () => {
        return { name: 'profile-details' }
      }
    },
    audienceRoute: {
      type: Object,
      default: () => {
        return { name: 'profile-audience' }
      }
    }
  }
}
</script>
